import { useId } from 'react';
import { SCALE_MAX, SCALE_MIN } from '@kraftwerk/shared';

const STEPS = Array.from({ length: SCALE_MAX - SCALE_MIN + 1 }, (_, index) => SCALE_MIN + index);

/**
 * Eine Skala von 1 bis 5 — für Bewertung, Energie, Stimmung, Schlaf, Muskelkater.
 *
 * Beide Enden stehen beschriftet daneben: „3" heißt bei Muskelkater etwas
 * anderes als bei Stimmung, und eine Zahl ohne Richtung ist ein Rätsel.
 * Nochmals Tippen auf den gewählten Wert nimmt ihn zurück — „nicht angegeben"
 * muss erreichbar bleiben, sonst behauptet ein Fehltipp etwas.
 */
export function ScalePicker({
  label,
  low,
  high,
  value,
  onChange,
  large = false,
}: {
  label: string;
  low: string;
  high: string;
  value: number | null;
  onChange: (value: number | null) => void;
  large?: boolean;
}): React.JSX.Element {
  const labelId = useId();

  return (
    <div role="group" aria-labelledby={labelId} className="flex flex-col gap-1">
      <span id={labelId} className="kw-label">
        {label}
      </span>
      <div className="flex gap-1">
        {STEPS.map((step) => {
          const active = value === step;
          return (
            <button
              key={step}
              type="button"
              aria-pressed={active}
              aria-label={`${label}: ${step} (${low} … ${high})`}
              onClick={() => onChange(active ? null : step)}
              className={`kw-btn ${large ? '' : 'kw-btn-small'} flex-1 px-0 ${
                active ? '' : 'kw-btn-quiet'
              }`}
            >
              {step}
            </button>
          );
        })}
      </div>
      <div className="flex justify-between text-xs text-ink-muted" aria-hidden="true">
        <span>{low}</span>
        <span>{high}</span>
      </div>
    </div>
  );
}
